var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.037 0c.701 0 1.273.557 1.273 1.251v16.786c0 .69-.572 1.251-1.273 1.251H1.273v.257c0 .345.288.628.64.628h14.784c.35 0 .639-.283.639-.628v-2.6h1.273v2.604c0 1.035-.86 1.88-1.912 1.88H1.912C.86 21.429 0 20.584 0 19.549V1.251C0 .561.571 0 1.273 0ZM8.12 10.873c-1.488 0-4.464.793-4.464 2.234v.721h8.928v-.72c0-1.442-2.976-2.235-4.464-2.235Zm.054-5.384c-1.25 0-2.259.967-2.259 2.164s1.01 2.164 2.26 2.164c1.249 0 2.258-.967 2.258-2.164S9.425 5.49 8.175 5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.037 6.767h-1.556v3.947h1.556c.387 0 .7-.36.7-.807V7.574c0-.446-.313-.807-.7-.807Zm0 5.075h-1.556v3.947h1.556c.387 0 .7-.36.7-.807V12.65c0-.447-.313-.808-.7-.808Zm0-9.586h-1.556v3.947h1.556c.387 0 .7-.361.7-.808V3.063c0-.446-.313-.807-.7-.807Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContacts);
export default __webpack_public_path__ + "static/media/ic-contacts.fa67b0bc5d74603799a8815c9871c0bb.svg";
export { ForwardRef as ReactComponent };